module.exports = __webpack_public_path__ + "static/media/8.a4ee0026.jpg";